export default __webpack_public_path__ + "static/media/troll-dad-83.1ee47560.png";